import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/storage';

import { Plugins } from '@capacitor/core';
const { Storage } = Plugins;

import Google from './Google';
import Model from './Model';
import Values from './Values';
const moment = require('moment');

export default class Entry extends Model {

  id = null;
    key = null;
    form = null;
    title = '';
    user = '';
    created = '';
    ordinal = 0;
    pending = false;
    values = new Values();

    constructor(data = {}) {
        super(data);
        this.values = new Values();
        Object.assign(this, data);
    }

    async store() {
        await Storage.set({
            key: `entries/${this.form}/${this.id}`,
            value: JSON.stringify(this)
        });
        return this;
    }

    static async restore(formId, entryId) {
        const item = await Storage.get({ key: `entries/${formId}/${entryId}` });
        let json = JSON.parse(item.value);
        let entry = new Entry(json);
        entry.values = new Values();
        if (json.values && json.values.length > 0) {
            for (let _value of json.values) {
                let value = new Value(_value);
                entry.values.push(value);
            }
        }
        return entry;
    }

    async save() {
        if (this.key == null || this.key == undefined || this.key == "null" || this.key.length == 0) {
            throw "The form key for the entry has not been set";
        }
        let values = [this.author, this.created];
        for (let value of this.values) {
            if (value.type === 'date') {
                let date = moment(value.value).format("YYYY-MM-DD");
                values.push(date);
            }
            else if (value.type === 'time') {
                let time = moment(value.value).format("HH:mm:ss");
                values.push(time);
            }
            else if (value.type === 'datetime') {
                let datetime = moment(value.value).format("YYYY-MM-DD HH:mm:ss");
                values.push(datetime);
            }
            else if (value.type === 'image') {
                let path = `${value.id}.jpg`;
                let url = await this.uploadGoogle(path, value.value);
                values.push(url);
            }
            else if (value.type === 'signature') {
                let path = `${value.id}.jpg`;
                let url = await this.uploadGoogle(path, value.value);
                values.push(url);
            }
            else {
                values.push(value.value);
            }
        }
        let column = String.fromCharCode(96+values.length).toUpperCase();
        let range = `Sheet1!A2:${column}2`;
        let params = {
            "range": range,
            "majorDimension": "ROWS",
            "values": [values]
        };
        let url = `https://sheets.googleapis.com/v4/spreadsheets/${this.key}/values/${range}:append?valueInputOption=USER_ENTERED`;
        await Google.post(url, params);
        return this;
    }

    async uploadFirebase(path, data) {
        let storageRef = firebase.storage().ref();
        let imageRef = storageRef.child('images').child(path);
        let snapshot = await imageRef.putString(data, 'data_url');
        return await snapshot.ref.getDownloadURL();
    }

    async uploadGoogle(path, data) {
        let image = data.replace("data:image/jpeg;base64,", "");
        let metadata = {
            'name': path, 
            'mimeType': 'image/jpeg'
        };
        let form = {
            metadata: {
                type: 'application/json; charset=UTF-8',
                value: JSON.stringify(metadata)
            },
            file: {
                type: 'image/jpeg',
                value: image
            }
        };
        let boundary = "nVenJ7H4puv";
        let params = this.contentDisposition(boundary, form);
        let contentType = "multipart/related; boundary=" + boundary;
        let url = `https://www.googleapis.com/upload/drive/v3/files?uploadType=multipart`;
        let response = await Google.post(url, params, contentType);
        return `https://drive.google.com/uc?id=${response.id}`;
    }

    contentDisposition(boundary, data) {
        let body = "";
        for (let key in data) {
            body += "--" + boundary
                 + "\r\nContent-Disposition: form-data; name=" + key
                 + "\r\nContent-type: " + data[key].type
                 + (key == "file" ? "\r\nContent-Transfer-Encoding: base64" : "")
                 + "\r\n\r\n" + data[key].value + "\r\n";
        }
        body += "--" + boundary + "--\r\n";
        return body;
    }

    setID(name, date) {
        this.id = `${name}-${date}`.trim().toLowerCase().replace(/[^a-zA-Z0-9 -]/, "").replace(/\s/g, "-");
    }

}